import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { Invoice, InvoiceChartData } from './invoice-status.interface';

@Component({
  selector: 'app-invoice-status',
  templateUrl: './invoice-status.component.html',
  styleUrls: ['./invoice-status.component.scss'],
})
export class InvoiceStatusComponent implements OnInit {
  public invoice!: Invoice;
  public totalRevenue!: number;
  public initializeChart = false;
  totalValue: number = 0;
  loading = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}
  chartWidth = 190;
  chartHeight = 170;
  strokeWidth = '20';
  public invoiceStatus: InvoiceChartData[] = [
    {
      id: 1,
      color: '#a1a1a1',
      value: 0,
    },
    {
      id: 2,
      color: '#5bb362',
      value: 0,
    },
    {
      id: 3,
      color: '#f19c4a',
      value: 0,
    },
    {
      id: 4,
      color: '#ff735e',
      value: 0,
    },
    {
      id: 5,
      color: '#377dc7',
      value: 0,
    },
  ];
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.loading = true;
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.homeServiceRef.getInvoice(id).subscribe((res) => {
        if (!!res) {
          this.invoice = res;
          this.totalRevenue = res.issued + res.open + res.paid + res.pending;
          this.invoiceStatus[1].value =
            (res.paid / this.totalRevenue) * 100 || 0;
          this.invoiceStatus[2].value =
            (res.open / this.totalRevenue) * 100 || 0;
          this.invoiceStatus[3].value =
            (res.pending / this.totalRevenue) * 100 || 0;
          this.invoiceStatus[4].value =
            (res.issued / this.totalRevenue) * 100 || 0;
          this.totalValue = this.invoiceStatus.reduce(function (
            acc: number,
            obj
          ) {
            return acc + obj.value;
          },
          0);
          this.invoiceStatus[4].value == 0
            ? (this.invoiceStatus[4].color = '#a1a1a1')
            : '#377dc7';
          this.invoiceStatus[0].value = 100 - this.totalValue;
          this.loading = false;
          this.initializeChart = true;
        }
      });
    }
  }
}
